<template lang="pug">
.run-time-wrap
  span {{ title }}
  span.run-time {{ translateTime }}
</template>
<script>
export default {
  name: "run-time-wrap",
  props: {
    title: {
      type: String,
      default: "运行时间",
      required: false,
    },
    series: {
      required: false,
    },
    isHour: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    translateTime() {
      if (!this.series) {
        return "未启动";
      }
      let day = Number(this.series) / 60 / 24;
      if (this.isHour) {
        day = day * 60;
      }
      const hours = (day % 1) * 24;
      const minutes = (hours % 1) * 60;
      return `${Math.floor(day)}天${Math.floor(hours)}时${Math.floor(minutes)}分`;
    },
  },
};
</script>
<style lang="scss" scoped>
.run-time-wrap {
  height: 42px;
  display: flex;
  justify-content: space-between;
  background-color: rgba(255, 255, 255, 0.6);
  min-width: 400px;
  padding: 0 20px;
  align-items: center;
}
</style>
